import { useReducer, useContext, createContext, useMemo } from 'react'
import reducers, { actionTypes } from './reducers'

const StateContext = createContext()

const initialState = {
  stores: [],
  user: null,
  currentStore: null,
  searchAll: false,
  search: null,
  drawer: {
    open: false
  },
  rental: null,
  notification: {
    open: false,
    data: { message: '', type: '' }
  }
}
const reducer = (state, action) => {
  if (reducers[action.type]) {
    return reducers[action.type](state, action)
  }
  return state;
}


export const useData = () => {
  const context = useContext(StateContext)
  if (context === undefined) {
    throw new Error(`useData must be used within a DataProvider`)
  }
  return context
}

export const DataProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const dispatchCurrentStore = payload => dispatch({ type: actionTypes.SELECT_STORE, payload })
  const dispatchHydrateLocal = payload => dispatch({ type: actionTypes.HYDRATE_LOCAL_STATE, payload })
  const dispatchSearchAll = payload => dispatch({ type: actionTypes.SET_SEARCH_ALL, payload })
  const dispatchUser = payload => dispatch({ type: actionTypes.SET_USER, payload })
  const dispatchSearch = payload => dispatch({ type: actionTypes.HANDLE_SEARCH, payload })
  const dispatchDrawer = payload => dispatch({ type: actionTypes.HANDLE_DRAWER, payload })
  const dispatchRental = payload => dispatch({ type: actionTypes.HANDLE_RENTAL, payload })
  const dispatchNotificationOpen = payload => dispatch({ type: actionTypes.HANDLE_NOTIFICATION_OPEN, payload })
  const dispatchNotificationData = payload => dispatch({ type: actionTypes.HANDLE_NOTIFICATION_DATA, payload })
  // const dispatchItems = payload => dispatch({ type: actionTypes.HANDLE_ITEMS, payload })
  const dispatchNotification = (data) => {
    dispatchNotificationData(data)
    dispatchNotificationOpen(true)
    setTimeout(() => {
      dispatchNotificationOpen(false)
    }, 1300)
  }
  
  const value = useMemo(
    () => ({
      ...state,
      dispatchCurrentStore,
      dispatchHydrateLocal,
      dispatchSearchAll,
      dispatchUser,
      dispatchSearch,
      dispatchDrawer,
      dispatchRental,
      dispatchNotificationOpen,
      dispatchNotificationData,
      dispatchNotification
    }),
    [state],
  )
  return (
      <StateContext.Provider value={value}>
        {children}
      </StateContext.Provider>
  )
}

export const useDataState = () => useContext(StateContext)